import { _ as oi } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.assign-7e79fd7b.js";
import { c as S } from "./index-8b07dec9.js";
import ti, { useRef as Y, useState as z, useLayoutEffect as ri } from "react";
import { getAriaProps as Z } from "./aria.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.is-array-7a29277f.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.to-string-f55666a8.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as ii } from "./getMetrics-953aa4f8.js";
import { CloseButton as ai } from "./closeButton.js";
import { _ as p } from "./taggedTemplateLiteralLoose-b7a1029e.js";
import { styled as s, css as c } from "styled-components";
import { Badge as li } from "./badge.js";
import { a as ni } from "./index-5d0f31c6.js";
import { jsxs as l, jsx as o, Fragment as R } from "react/jsx-runtime";
import { BREAKPOINTS as T } from "@ucl/shared-component-foundations";
import "./es.object.keys-9d66766f.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import { useSlots as pi } from "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { useWindowSize as si } from "./useWindowSize.js";
import { Button as k } from "./button.js";
import { ModalWindow as x } from "./modalWindow.js";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./es.array.filter-4e9c9996.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./iterate-13ada9e5.js";
import "./classof-21a3574e.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import "./function-apply-4756dee6.js";
import "./to-string-92a62764.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./array-method-is-strict-e5a3c878.js";
import "./iconButton.js";
import "./es.date.to-string-6ed49878.js";
import "./es.regexp.to-string-e800d529.js";
import "./es.string.small-23219181.js";
import "./string-html-forced-a746405b.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-icons";
import "./environment-ddee5959.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./combineRefs-c9ad2c39.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./useClient.js";
import "./disclosure.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.from-fe752fa6.js";
import "./es.array.index-of-084b82ab.js";
import "./useOnClickOutside.js";
import "./index-55eee02a.js";
import "./tslib.es6-59e1c9d8.js";
import "./hooks_internal.js";
import "./analytics.js";
var K, V, E, F, ci = s.div(K || (K = p([`
  &.Chip {
    `, `;
  }
`])), function(e) {
  var i = e.theme.components.chip;
  return c(i.Chip);
}), mi = s.div(V || (V = p([`
  &.Chip__leading-icon {
    `, `;
  }
`])), function(e) {
  var i = e.theme.components.chip;
  return c(i.LeadingIconWrapper);
}), di = s(ni)(E || (E = p([`
  &.Chip__toggle-icon {
    `, `;
  }
`])), function(e) {
  var i = e.theme.components.chip;
  return c(i.ToggleIcon);
}), hi = s(li)(F || (F = p([`
  &.Chip__badge {
    `, `;
  }
`])), function(e) {
  var i = e.theme.components.chip;
  return c(i.ChipBadge);
}), ui = ["size", "variant", "isDisabled", "children", "onClick", "isRadio", "leadingIcon", "badgeProps", "isActive", "onDelete", "isOpen", "accessibilityOptions"], bi = function(i) {
  var _ = i.size, L = _ === void 0 ? "medium" : _, f = i.variant, n = f === void 0 ? "toggle" : f, m = i.isDisabled, r = m === void 0 ? !1 : m, d = i.children, b = i.onClick, N = i.isRadio, g = i.leadingIcon, B = i.badgeProps, t = B === void 0 ? {} : B, P = i.isActive, v = P === void 0 ? !1 : P, O = i.onDelete, y = i.isOpen, $ = y === void 0 ? !1 : y, h = i.accessibilityOptions, G = h === void 0 ? {} : h, w = oi(i, ui), j = ii({
    label: "Chip"
  }), D = n === "toggle", C = Y(null), A = n === "toggle" && "button" || "combobox", I = Z(A, Object.assign({
    ariaLabel: w["aria-label"] || d,
    ariaDisabled: r
  }, n === "toggle" && {
    ariaPressed: v
  }, G.chip)), u = function(a) {
    r || b == null || b(a, {
      type: n,
      label: d,
      values: [],
      isActive: !v
    });
  }, ei = function(a) {
    (a.code === "Enter" || a.code === "Space") && (a.preventDefault(), u(a));
  };
  return /* @__PURE__ */ l(ci, Object.assign({}, w, {
    onClick: u,
    onKeyDown: ei,
    tabIndex: 0,
    "data-type": "chip",
    className: S(["Chip", "Chip--" + L, "Chip--" + n, {
      "Chip--disabled": r,
      "Chip--active": v,
      "Chip--clickable": !!b,
      "Chip--removable": !!O
    }, w.className]),
    ref: C,
    role: A
  }, I, j, {
    children: [g && /* @__PURE__ */ o(mi, {
      className: "Chip__leading-icon",
      children: g
    }), /* @__PURE__ */ o("span", {
      children: d
    }), (t == null ? void 0 : t.value) && !N && /* @__PURE__ */ o(hi, Object.assign({
      className: S(["Chip__badge", {
        "Chip__badge--disabled": r
      }])
    }, t)), O && /* @__PURE__ */ o(ai, {
      className: S(["Chip__close-btn", {
        "Chip__close-btn--disabled": r
      }]),
      disabled: r,
      onClick: function(a) {
        var W;
        r || (a.stopPropagation(), O(), (W = C.current) == null || W.focus());
      },
      onKeyDown: function(a) {
        a.stopPropagation();
      },
      tabIndex: r ? void 0 : 0,
      size: "xxsmall",
      accessibilityOptions: Object.assign({
        ariaLabel: "remove " + d.toLowerCase()
      }, G.removeButton)
    }), !D && /* @__PURE__ */ o(di, {
      className: "Chip__toggle-icon",
      icon: $ ? "caretUp" : "caretDown",
      height: "20px",
      width: "20px"
    })]
  }));
}, q, H, U, J, Q = s.div(q || (q = p([`
  &.ChipGroup {
    `, `;
  }
`])), function(e) {
  var i = e.theme.components.chip;
  return c(i.ChipGroup);
}), X = s.label(H || (H = p([`
  &.ChipGroup__label {
    `, `;
  }
`])), function(e) {
  var i = e.theme.components.chip;
  return c(i.ChipGroupLabel);
}), vi = s.div(U || (U = p([`
  &.ChipGroup__actions {
    `, `;
  }
`])), function(e) {
  var i = e.theme.components.chip;
  return c(i.ActionButtonWrapper);
}), Ci = s(x.Body)(J || (J = p([`
  &.ChipGroup__ModalBody {
    `, `;
  }
`])), function(e) {
  var i = e.theme.components.chip;
  return c(i.ModalBody);
}), Qe = function(i) {
  var _, L, f = i.children, n = i.onClear, m = i.label, r = i.modalProps, d = r === void 0 ? {
    title: "Filter Results",
    buttonText: "Close"
  } : r, b = i.clearAllLabel, N = b === void 0 ? "Clear all" : b, g = i.showAllLabel, B = g === void 0 ? "Show all" : g, t = i.accessibilityOptions, P = ii({
    label: "ChipGroup"
  }), v = pi(f, {
    Chip: bi
  }), O = Y(null), y = z(!1), $ = y[0], h = y[1], G = z(15), w = G[0], j = G[1], D = si(), C = D.width, A = ti.Children.count(f), I = function() {
    C >= T.laptopMin ? j(15) : C >= T.tabletMin ? j(10) : j(5);
  };
  return ri(function() {
    I();
  }, [C]), /* @__PURE__ */ l(R, {
    children: [/* @__PURE__ */ l(Q, Object.assign({
      className: "ChipGroup",
      ref: O
    }, P, {
      children: [m && /* @__PURE__ */ o(X, {
        className: "ChipGroup__label",
        "data-type": "chip-label",
        children: m
      }), v.Chip, /* @__PURE__ */ l(vi, {
        className: "ChipGroup__actions",
        children: [/* @__PURE__ */ o(k, Object.assign({
          onClick: n,
          fullWidthMobile: !1,
          className: "ChipGroup__action ChipGroup__clear-all-btn",
          tabIndex: 0,
          variant: "tertiary",
          size: "small",
          name: "clear-all"
        }, t == null ? void 0 : t.clearAll, {
          children: N
        })), A > w && /* @__PURE__ */ l(R, {
          children: [/* @__PURE__ */ o("div", {
            className: "separator",
            children: "|"
          }), /* @__PURE__ */ l(k, Object.assign({
            className: "ChipGroup__action ChipGroup__show-all-btn",
            onClick: function() {
              return h(!0);
            },
            fullWidthMobile: !1,
            tabIndex: 0,
            variant: "tertiary",
            size: "small",
            name: "show-all"
          }, t == null ? void 0 : t.showAll, {
            children: [B, " (", A, ")"]
          }))]
        })]
      })]
    })), /* @__PURE__ */ l(x, {
      variant: "large",
      isOpen: $,
      onClose: function() {
        return h(!1);
      },
      children: [/* @__PURE__ */ o(x.Header, Object.assign({
        onClose: function() {
          return h(!1);
        }
      }, Z("div", t == null || (_ = t.modal) == null ? void 0 : _.headerCloseButton), {
        children: d.title
      })), /* @__PURE__ */ l(Ci, {
        className: "ChipGroup__ModalBody",
        children: [/* @__PURE__ */ l(Q, {
          className: "ChipGroup ModalBody",
          children: [m && /* @__PURE__ */ o(X, {
            className: "ChipGroup__label",
            children: m
          }), $ && v.Chip]
        }), /* @__PURE__ */ o(k, {
          variant: "tertiary",
          size: "small",
          onClick: n,
          name: "clear-all",
          className: "ChipGroup__action ChipGroup__clear-all-btn",
          children: N
        })]
      }), /* @__PURE__ */ o(x.Footer, {
        placement: "right",
        children: /* @__PURE__ */ o(k, Object.assign({
          onClick: function() {
            return h(!1);
          }
        }, t == null || (L = t.modal) == null ? void 0 : L.footerActionButton, {
          children: d.buttonText
        }))
      })]
    })]
  });
};
export {
  bi as Chip,
  Qe as ChipGroup
};
